<template>
<div>
  <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
  </b-container>
  <div v-else>
    <div class="w-menu">
      <b-row class="m-menu-avatar w-cursor-click" @click="gotoProfile()">
        <b-col>
          <b-avatar v-if="currentProfilePicture" 
            size="50px" 
            v-bind:src="currentProfilePicture"
          >
          </b-avatar>
          <b-avatar v-else 
            size="50px" 
            :src="require('@/assets/img/profile-picture.jpg')"
          >
          </b-avatar>
        </b-col>
      </b-row>
      <b-row class="m-menu-under-avatar">
        <b-col style="padding:0" class="text-center">
            <p class="w-menu-name">{{currentUser.firstname}} {{currentUser.lastname}}</p>
            <p class="w-menu-email">{{currentUser.email}}</p>
        </b-col>
      </b-row>
      <b-row class="d-flex flex-row justify-content-center" style="width:100%; margin:0">
        <div class="justify-content-left"  style="margin-left: -30px;">
          <p class="w-menuitem-1" style="top:191px;color:white">cellar </p>
          <p class="w-menuitem-3 w-cursor-click" style="top:228px" @click="gotoDashboard()">{{translate("cellar")}}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:265px" @click="gotoDashboard()">{{translate("dashboard")}}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:302px" @click="gotoCellar()">{{translate("content")}}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:339px" @click="gotoSearch()">{{translate("search")}}</p>
          <p class="w-menuitem-3 w-cursor-click" style="top:376px" @click="gotoLibrary()">{{translate("library")}}</p>
          <p class="w-menuitem-3 w-cursor-click" style="top:413px" @click="gotoWishlist()">{{translate("wishlist")}}</p>
          <p class="w-menuitem-3 w-cursor-click" style="top:450px" @click="gotoArchive()">{{translate("archive")}}</p>
          <p class="w-menuitem-3 w-cursor-click" style="top:487px" @click="gotoTools()">{{translate("tools")}}</p>
          <p class="w-menuitem-3 w-cursor-click" style="top:524px" @click="gotoAboutUs()">{{translate("about us")}}</p> 
          <p class="w-menuitem-3 w-cursor-click" style="top:561px" @click="logOut()">{{translate("log off")}}</p>
        </div>
        <div v-if="this.currentPage=='Dashboard'" class="w-current-item-mobile" style="top:263px"/>
        <div v-if="this.currentPage=='Cellar'" class="w-current-item-mobile" style="top:300px"/>
        <div v-if="this.currentPage=='Search'" class="w-current-item-mobile" style="top:337px"/>
        <div v-if="this.currentPage=='Library'" class="w-current-item-mobile" style="top:374px"/>
        <div v-if="this.currentPage=='Wishlist'" class="w-current-item-mobile" style="top:411px"/>
        <div v-if="this.currentPage=='Archive'" class="w-current-item-mobile" style="top:448px"/>
        <div v-if="this.currentPage=='Tools'" class="w-current-item-mobile" style="top:485px"/>
        <div v-if="this.currentPage=='AboutUs'" class="w-current-item-mobile" style="top:522"/>
      </b-row>
      
    </div>
  </div>
</div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  export default {
    computed : {
      currentUser() {
        return this.$store.state.user
      },
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      }
    },
    data() {
      return {
        isLoading : true,
      }
    },
    async mounted() {
      this.isLoading = false
    },
    methods:{
      gotoProfile() {
        this.$store.commit('setPage','Profile')
        this.$router.push({path:'/Profile', query: {cellar_id:this.$route.query.cellar_id}})
      },
      gotoDashboard() {
        if (this.currentPage != 'Dashboard') {
          this.$store.commit('setPage','Dashboard')
          this.$router.push({path:'/Dashboard', query: {cellar_id:this.$route.query.cellar_id }} );
        }
      },
      gotoCellar() {
        this.$store.commit('setSearchState',{})
        this.$store.commit('setPage','Cellar')
        this.$router.push({path:'/Cellar', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoTastings() {
        this.$store.commit('setPage','Tastings')
        this.$router.push({path:'/Tastings', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoSearch() {
        this.$store.commit('setSearchState',{})
        this.$store.commit('setPage','Search')
        this.$router.push({path:'/Search', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoLibrary() {
        this.$store.commit('setSearchState',{})
        this.$store.commit('setPage','Library')
        this.$router.push({path:'/Library', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoWishlist() {
        this.$store.commit('setPage','Wishlist')
        this.$router.push({path:'/Wishlist', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoArchive() {
        this.$store.commit('setPage','Archive')
        this.$router.push({path:'/Archive', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoTools() {
        this.$store.commit('setPage','Tools')
        this.$router.push({path:'/Tools', query: {cellar_id:this.$route.query.cellar_id }} );
      },
      gotoAboutUs() {
        this.$store.commit('setPage','AboutUs')
        this.$router.push({path:'/AboutUs'} );
      },  
      logOut() {
        this.$store.commit('logout')
        this.$store.commit('setCellarLoaded', false)
        this.$router.push({path:'/'})
      },

      translate(string) {
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
</style>